var exports = {
  "kL": "x31de4314--c4d5c9--container",
  "yJ": "x31de4314--c4d5c9--links",
  "nf": "x31de4314--c4d5c9--link",
};

module.exports = exports;
